import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';
import { entityLikeSchema, entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { CctvCheckersEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-checkers.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';

import  * as yup from 'yup';

/** Resident car request body */
export interface ResidentCarFormInterface {
  /** State registration number of the car */
  carNumber: string;
  /** Client who owns this car */
  client: ClientFindInterface;
  /** Car category */
  category?: CarCategoryFindInterface;
  /** Resident car owner */
  owner?: ExternalUserFindInterface;
  /** The rooms to which this car is granted access */
  rooms?: RoomFindInterface[];
}

/** Resident car request body - DTO schema */
export const ResidentCarFormDto = SerdeDtoClass.create<ResidentCarFormInterface>(CctvDtoKeysEnum.RESIDENT_CAR_FORM_DTO, {
  carNumber: {
    label: 'Номер ТС',
    serializer: nonEmptyStringSchema,
  },
  client: {
    label: 'Клиент',
    serializer: entityLikeSchemaStrict,
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
  },
  category: {
    optional: true,
    label: 'Категория ТС',
    serializer: entityLikeSchema,
    checkers: [CctvCheckersEnum.CAR_CATEGORY_ASSERT_EXISTS_BY_DTO],
  },
  owner: {
    optional: true,
    label: 'Владелец',
    serializer: entityLikeSchemaStrict,
    checkers: [SecurityBackendValidatorsEnum.EXTERNAL_USER_ASSERT_EXISTS_BY_DTO],
  },
  rooms: {
    label: 'Помещения',
    serializer: yup
      .array(entityLikeSchema)
      .min(1, DtoMessageEnum.EMPTY_ARRAY),
    checkers: [CatalogCheckersEnum.ROOM_ASSERT_EXISTS_BY_DTO],
  },
});
